/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/source_application';
import '../../common/money';
import '../../catalog/resources/datatypes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "inventory": {
                "nested": {
                  "resources": {
                    "nested": {
                      "InventoryState": {
                        "values": {
                          "INVENTORY_STATE_DO_NOT_USE": 0,
                          "CUSTOM": 1,
                          "IN_STOCK": 2,
                          "SOLD": 3,
                          "RETURNED_BY_CUSTOMER": 4,
                          "RESERVED_FOR_SALE": 5,
                          "SOLD_ONLINE": 6,
                          "ORDERED_FROM_VENDOR": 7,
                          "RECEIVED_FROM_VENDOR": 8,
                          "IN_TRANSIT_TO": 9,
                          "NONE": 10,
                          "WASTE": 11,
                          "UNLINKED_RETURN": 13,
                          "COMPOSED": 14,
                          "DECOMPOSED": 15,
                          "SUPPORTED_BY_NEWER_VERSION": 16,
                          "IN_TRANSIT": 17,
                          "UNTRACKED": 18
                        }
                      },
                      "AvailabilityState": {
                        "values": {
                          "UNKNOWN_DO_NOT_USE": 0,
                          "SOLD_OUT": 1,
                          "AVAILABLE": 2
                        }
                      },
                      "AvailabilityRuleType": {
                        "values": {
                          "AVAILABILITY_RULE_TYPE_DO_NOT_USE": 0,
                          "STOCK": 1,
                          "COMPOSITION": 2,
                          "SALES_LIMIT_QUANTITY": 3,
                          "FORCE_UNAVAILABLE": 4,
                          "FORCE_AVAILABLE": 5,
                          "UNRECOGNIZED_AVAILABILITY_RULE_TYPE": 6,
                          "DEFAULT_AVAILABILITY": 7
                        }
                      },
                      "InventoryPhysicalCount": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "catalogObjectId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "catalogObjectType": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "status": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 5,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 12,
                            "rule": "optional"
                          },
                          "locationId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "source": {
                            "type": "squareup.connect.v2.common.SourceApplication",
                            "id": 8,
                            "rule": "optional"
                          },
                          "employeeId": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "teamMemberId": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "occurredAt": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "adjustmentId": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryCount": {
                        "fields": {
                          "catalogObjectId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "catalogObjectType": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "status": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 3,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 7,
                            "rule": "optional"
                          },
                          "locationId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "calculatedAt": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "availabilityState": {
                            "type": "squareup.connect.v2.inventory.resources.AvailabilityState",
                            "id": 8,
                            "rule": "optional"
                          },
                          "isEstimated": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "soldOutValidUntil": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "quantityCommitted": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "quantityAvailable": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "availabilityRule": {
                            "type": "squareup.connect.v2.inventory.resources.AvailabilityRuleType",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryAdjustment": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "fromStatus": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 3,
                            "rule": "optional"
                          },
                          "toStatus": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 4,
                            "rule": "optional"
                          },
                          "fromState": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 21,
                            "rule": "optional"
                          },
                          "toState": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 22,
                            "rule": "optional"
                          },
                          "fromLocationId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "toLocationId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "locationId": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "catalogObjectId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "catalogObjectType": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "totalCostMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 10,
                            "rule": "optional"
                          },
                          "totalPriceMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "occurredAt": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "source": {
                            "type": "squareup.connect.v2.common.SourceApplication",
                            "id": 14,
                            "rule": "optional"
                          },
                          "employeeId": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "teamMemberId": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "transactionId": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "refundId": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "purchaseOrderId": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "goodsReceiptId": {
                            "type": "string",
                            "id": 19,
                            "rule": "optional"
                          },
                          "adjustmentGroup": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryAdjustmentGroup",
                            "id": 23,
                            "rule": "optional"
                          },
                          "costMoney": {
                            "type": "squareup.connect.v2.common.Money",
                            "id": 25,
                            "rule": "optional"
                          },
                          "vendorId": {
                            "type": "string",
                            "id": 26,
                            "rule": "optional"
                          },
                          "physicalCountId": {
                            "type": "string",
                            "id": 27,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryTransfer": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "referenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 3,
                            "rule": "optional"
                          },
                          "fromLocationId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "toLocationId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "catalogObjectId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "catalogObjectType": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "quantity": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "occurredAt": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "source": {
                            "type": "squareup.connect.v2.common.SourceApplication",
                            "id": 11,
                            "rule": "optional"
                          },
                          "employeeId": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "teamMemberId": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryAvailability": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "catalogObjectId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "catalogObjectType": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "locationId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "state": {
                            "type": "squareup.connect.v2.inventory.resources.AvailabilityState",
                            "id": 5,
                            "rule": "optional"
                          },
                          "occurredAt": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "soldOutValidUntil": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryChangeType": {
                        "values": {
                          "INVENTORY_CHANGE_TYPE_DO_NOT_USE": 0,
                          "PHYSICAL_COUNT": 1,
                          "ADJUSTMENT": 2,
                          "TRANSFER": 3,
                          "AVAILABILITY": 4
                        }
                      },
                      "InventoryChange": {
                        "fields": {
                          "type": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryChangeType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "physicalCount": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryPhysicalCount",
                            "id": 2,
                            "rule": "optional"
                          },
                          "adjustment": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryAdjustment",
                            "id": 3,
                            "rule": "optional"
                          },
                          "transfer": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryTransfer",
                            "id": 4,
                            "rule": "optional"
                          },
                          "availability": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryAvailability",
                            "id": 5,
                            "rule": "optional"
                          },
                          "measurementUnit": {
                            "type": "squareup.connect.v2.merchant_catalog.resources.CatalogMeasurementUnit",
                            "id": 6,
                            "rule": "optional"
                          },
                          "measurementUnitId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "InventoryAdjustmentGroup": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "rootAdjustmentId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "fromState": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 3,
                            "rule": "optional"
                          },
                          "toState": {
                            "type": "squareup.connect.v2.inventory.resources.InventoryState",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryState && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.AvailabilityState && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.AvailabilityRuleType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryPhysicalCount && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryCount && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryAdjustment && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryTransfer && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryAvailability && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryChangeType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryChange && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.inventory?.nested?.resources?.nested?.InventoryAdjustmentGroup) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Indicates the state of a tracked item quantity in the lifecycle of goods.
 * --
 *
 * SOURCE InventoryState @ squareup/connect/v2/inventory/resources/inventory.proto at 24:1
 */
export const InventoryState = $root.lookupEnum('squareup.connect.v2.inventory.resources.InventoryState').values;
/**
 * --
 * @desc The availability state of a product, which may change over time.
 * --
 *
 * SOURCE AvailabilityState @ squareup/connect/v2/inventory/resources/inventory.proto at 134:1
 */
export const AvailabilityState = $root.lookupEnum('squareup.connect.v2.inventory.resources.AvailabilityState').values;
/**
 * SOURCE AvailabilityRuleType @ squareup/connect/v2/inventory/resources/inventory.proto at 153:1
 */
export const AvailabilityRuleType = $root.lookupEnum('squareup.connect.v2.inventory.resources.AvailabilityRuleType').values;
/**
 * --
 * @desc Represents the quantity of an item variation that is physically present
 * at a specific location, verified by a seller or a seller's employee. For example,
 * a physical count might come from an employee counting the item variations on
 * hand or from syncing with an external system.
 * --
 *
 * SOURCE InventoryPhysicalCount @ squareup/connect/v2/inventory/resources/inventory.proto at 200:1
 */
export const InventoryPhysicalCount = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryPhysicalCount');
fixType(InventoryPhysicalCount);
Builder.createAndAttachToType(InventoryPhysicalCount);
/**
 * --
 * @desc Represents Square-estimated quantity of items in a particular state at a
 * particular seller location based on the known history of physical counts and
 * inventory adjustments.
 * --
 *
 * SOURCE InventoryCount @ squareup/connect/v2/inventory/resources/inventory.proto at 301:1
 */
export const InventoryCount = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryCount');
fixType(InventoryCount);
Builder.createAndAttachToType(InventoryCount);
/**
 * --
 * @desc Represents a change in state or quantity of product inventory at a
 * particular time and location.
 * --
 *
 * SOURCE InventoryAdjustment @ squareup/connect/v2/inventory/resources/inventory.proto at 399:1
 */
export const InventoryAdjustment = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryAdjustment');
fixType(InventoryAdjustment);
Builder.createAndAttachToType(InventoryAdjustment);
/**
 * --
 * @desc Represents the transfer of a quantity of product inventory at a
 * particular time from one location to another.
 * --
 *
 * SOURCE InventoryTransfer @ squareup/connect/v2/inventory/resources/inventory.proto at 598:1
 */
export const InventoryTransfer = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryTransfer');
fixType(InventoryTransfer);
Builder.createAndAttachToType(InventoryTransfer);
/**
 * --
 * @desc Represents an inventory availability change of a particular product taking place at a
 * particular time in a particular location.
 * --
 *
 * SOURCE InventoryAvailability @ squareup/connect/v2/inventory/resources/inventory.proto at 694:1
 */
export const InventoryAvailability = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryAvailability');
fixType(InventoryAvailability);
Builder.createAndAttachToType(InventoryAvailability);
/**
 * --
 * @desc Indicates how the inventory change was applied to a tracked product quantity.
 * --
 *
 * SOURCE InventoryChangeType @ squareup/connect/v2/inventory/resources/inventory.proto at 747:1
 */
export const InventoryChangeType = $root.lookupEnum('squareup.connect.v2.inventory.resources.InventoryChangeType').values;
/**
 * --
 * @desc Represents a single physical count, inventory, adjustment, or transfer
 * that is part of the history of inventory changes for a particular
 * [CatalogObject](entity:CatalogObject) instance.
 * --
 *
 * SOURCE InventoryChange @ squareup/connect/v2/inventory/resources/inventory.proto at 779:1
 */
export const InventoryChange = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryChange');
fixType(InventoryChange);
Builder.createAndAttachToType(InventoryChange);
/**
 * --
 * Inventory adjustments, involving a specified composed variation, grouped together as a single inventory adjustment.
 * --
 *
 * SOURCE InventoryAdjustmentGroup @ squareup/connect/v2/inventory/resources/inventory.proto at 830:1
 */
export const InventoryAdjustmentGroup = $root.lookupType('squareup.connect.v2.inventory.resources.InventoryAdjustmentGroup');
fixType(InventoryAdjustmentGroup);
Builder.createAndAttachToType(InventoryAdjustmentGroup);